<template>
  <v-dialog
    v-model="open"
    hide-overlay
    max-width="690"
  >
    <v-card class="pa-2">
      <v-card-text>

        <div class="d-flex justify-content-center align-items-center mt-10 color-blue font-general-r">
          <img class="img-popup-message" src="@/assets/store/iconos/bolsa.svg" alt="">
          <div class="ml-5 text-center">
            <h5>{{ message }}</h5>
          </div>
        </div>

      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="accent"
          text
          @click="open = false"
        >
          CONTINUAR
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["message"],
  data() {
    return {
      open: false
    }
  },
  methods: {
    openDialog() {
      this.open = true;
    },
    close() {
      this.open = false;
    }
  }
}
</script>

<style scoped>
  .img-popup-message {
    width: 150px
  }
</style>
